"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const icons_1 = require("@ant-design/icons");
const BillingProfileForm_1 = require("./BillingProfileForm");
const BillingProfile = () => {
    const history = (0, react_router_1.useHistory)();
    const { billingProfileId } = (0, react_router_1.useParams)();
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { className: "p-l", children: [(0, jsx_runtime_1.jsx)(elements_1.Button, { type: "default", size: "middle", className: "m-b-m", onClick: () => history.pushLocalized('/admin/platby'), icon: (0, jsx_runtime_1.jsx)(icons_1.ArrowLeftOutlined, { className: "m-r-s" }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.buttons.back" }) }), (0, jsx_runtime_1.jsx)(BillingProfileForm_1.BillingProfileForm, { billingProfileId: Number(billingProfileId), onSubmit: () => history.pushLocalized('/admin/platby') })] }));
};
exports.default = BillingProfile;
